require('../../favorites/favoritesService');

"use strict";

angular.module('app.myHockeyTv.upcomingSchedule', [
  'app.favorites.favoritesService'
])
  .config([
    '$stateProvider',
    function ($stateProvider) {
      $stateProvider.state('app.myHockeyTv.upcomingSchedule', {
        url: '/upcoming_schedule',
        templateUrl: 'components/myHockeyTv/upcomingSchedule/upcomingScheduleView.html',
        subTitle: 'Upcoming Schedule (Favorites)',
        isChildState: true,
        controller: [
          '$scope',
          'app.favorites.favoritesService',
          function ($scope, favoritesService) {
            let oldFavorites = favoritesService.selected;

            $scope.$on('$destroy', function () {
              favoritesService.selected = oldFavorites;
            })
          }
        ]
      });
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/myHockeyTv/upcomingSchedule/upcomingSchedule.js